import { Button, styled } from '@ltvco/refresh-lib/theme';

export const DeleteAllButton = styled(Button)({
  minWidth: 0,
  padding: 0,
  textTransform: 'none',
  fontWeight: 400,
  fontSize: '0.75rem',
});
